import React from 'react';
import echarts from 'echarts';
import 'echarts/theme/macarons';
import _ from 'lodash';
import moment from 'moment';
import { injectIntl } from 'react-intl';

import elementResizeEvent from 'element-resize-event';
import CHARTCONFIG from 'constants/ChartConfig';

class ReactEchartUptime extends React.Component {
  // first add
  componentDidMount() {
    const echartObj = this.renderEchartDom();
    const onEvents = this.props.onEvents || {};
    let reizeEvent;

    this.bindEvents( echartObj, onEvents );
    // on chart ready
    if( typeof this.props.onChartReady === 'function' ) this.props.onChartReady( echartObj );

    function resize() {
      clearTimeout( reizeEvent );
      reizeEvent = setTimeout( () => { echartObj.resize(); }, 200 );
    }

    // on resize
    elementResizeEvent( this.echartsDom, () => {
      resize();
    } );
  }

  // update
  componentDidUpdate() {
    this.renderEchartDom();
    this.bindEvents( this.getEchartsInstance(), this.props.onEvents || [] );
  }

  // remove
  componentWillUnmount() {
    echarts.dispose( this.echartsDom );
  }

  // bind the events
  bindEvents( instance, events ) {
    const loop = function loop( eventName ) {
      // ignore the event config which not satisfy
      if( typeof eventName === 'string' && typeof events[eventName] === 'function' ) {
        // binding event
        instance.off( eventName );
        instance.on( eventName, ( param ) => {
          events[eventName]( param, instance );
        } );
      }
    };

    for( const eventName in events ) {
      loop( eventName );
    }

  }

  castDate(date) {
    let dateMod = date;
    dateMod = dateMod.split(/[^a-zA-Z0-9+]/g)
    const months = {'Jan':'01','Feb':'02','Mar':'03','Apr':'04',
				  'May':'05','Jun':'06','Jul':'07','Aug':'08',
          'Sep':'09','Oct':'10','Nov':'11','Dec':'12'};
          
    return moment( `${dateMod[0]}-${months[dateMod[1]]}-${dateMod[2]}`).format( 'DD-MM' );
  }

  // render the dom
  renderEchartDom() {
    const { intl, data = {}, chatActive, phoneActive } = this.props;

    const series = [
      intl.formatMessage( { id: "db_status" } ),
      intl.formatMessage( { id: "email_status" } ),
      intl.formatMessage( { id: "facebook_status" } ),
      intl.formatMessage( { id: "incms_status" } ),
      intl.formatMessage( { id: "twitter_status" } ),
      //intl.formatMessage( { id: "whatsapp_status" } ),
      //intl.formatMessage( { id: "sms_status" } ),
    ];
    //if( phoneActive ) series.push( intl.formatMessage( { id: "phone" } ) )

    const seriesY = [
      {
        name: intl.formatMessage( { id: "db_status" } ),
        type: 'line',
        data: _.map(data.db_status)
      },
      {
        name: intl.formatMessage( { id: "email_status" } ),
        type: 'line',
        data: _.map(data.email_status)
      },
      {
        name: intl.formatMessage( { id: "facebook_status" } ),
        type: 'line',
        data: _.map(data.facebook_status)
      },
      {
        name: intl.formatMessage( { id: "incms_status" } ),
        type: 'line',
        data: _.map(data.incms_status)
      },
      {
        name: intl.formatMessage( { id: "twitter_status" } ),
        type: 'line',
        data: _.map(data.twitter_status)
      },
      /*{
        name: intl.formatMessage( { id: "whatsapp_status" } ),
        type: 'line',
        data: _.map(data.whatsapp_status)
      }, */
    ];
    /*if( phoneActive ) seriesY.push( {
      name: intl.formatMessage( { id: "sms_status" } ),
      type: 'line',
      data: _.map(data.sms_status)
    } )
    */
 


    const options = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: series,
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      toolbox: {
        show: true,
      },
      calculable: false,
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: _.map( _.keys( data['incms_status'] ), ( item ) => item),
          axisLabel: {
            textStyle: {
              color: CHARTCONFIG.color.text
            }
          },
          splitLine: {
            lineStyle: {
              color: CHARTCONFIG.color.splitLine
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: CHARTCONFIG.color.text
            }
          },
          splitLine: {
            lineStyle: {
              color: CHARTCONFIG.color.splitLine
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: CHARTCONFIG.color.splitArea
            }
          }
        }
      ],
      series: seriesY
    };
    // init the echart object
    const echartObj = this.getEchartsInstance();
    // set the echart option
    echartObj.setOption( options, this.props.notMerge || false, this.props.lazyUpdate || false );
    // set loading mask
    if( this.props.showLoading ) echartObj.showLoading( this.props.loadingOption || null );
    else echartObj.hideLoading();

    return echartObj;
  }

  getEchartsInstance() {
    // return the echart object
    const theme = this.props.theme ? this.props.theme : 'macarons';
    return echarts.getInstanceByDom( this.echartsDom ) || echarts.init( this.echartsDom, theme );
  }

  render() {
    const style = this.props.style || {
      height: '350px'
    };
    // for render
    return (
      <div
        ref={( c ) => { this.echartsDom = c; }}
        className={this.props.className}
        style={style}/>
    );
  }
}

module.exports = injectIntl( ReactEchartUptime );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/ReactEChartUptime.js